<template>
  <div
    class="pay-now-container"
    @click.stop
  >
    <div class="body">
      <div class="payment-price">
        <div class="text">
          Awaiting Payment
        </div>
        <div class="price">
          <span>$</span>
          <span>{{ data.b2bOrderVo.totalAmountUsd }}</span>
          <span>USD</span>
        </div>
      </div>

      <div class="payment-methods">
        Payment Methods
      </div>
      <div class="sub-text">
        All transactions are secure and encrypted.
      </div>

      <div class="payment-options">
        <div
          @click="choosePaypal"
          class="option"
          :class="{ active: activeIndex === 1, disabled: disabledPaypal }"
        >
          <div class="radio">
            <img
              v-if="activeIndex === 1"
              src="@/assets/H5/order/radio-selected.svg"
              alt=""
            >
            <img
              v-else
              src="@/assets/H5/order/radio.svg"
              alt=""
            >
          </div>
          <div class="image">
            <img
              src="@/assets/H5/order/paypal.svg"
              alt=""
            >
          </div>
          <div class="desc">
            Pay with PayPal
          </div>
        </div>
        <div
          @click="activeIndex = 2"
          class="option"
          :class="{ active: activeIndex === 2 }"
        >
          <div class="radio">
            <img
              v-if="activeIndex === 2"
              src="@/assets/H5/order/radio-selected.svg"
              alt=""
            >
            <img
              v-else
              src="@/assets/H5/order/radio.svg"
              alt=""
            >
          </div>
          <div class="image">
            <img
              src="@/assets/H5/order/pay-with-bank.svg"
              alt=""
            >
          </div>
          <div class="desc">
            Pay with Bank
          </div>
        </div>
      </div>

      <div class="secure-payments">
        <div class="content">
          <div class="text">
            <div class="title">
              Secure Payments
            </div>
            <div class="desc">
              Each payment you make on Bestdealer is secured with strict SSL encryption and PCI DSS data protection protocols.
            </div>
          </div>
          <div class="image">
            <img
              src="@/assets/H5/order/secure-payment.svg"
              alt=""
            >
          </div>
        </div>
      </div>
      <div
        v-if="activeIndex === 1"
        style="height: 156px;"
      />
      <div
        v-if="activeIndex === 2"
        class="split-line"
      />
      <!-- paypal支付 -->
      <div
        class="paypal-button-container"
        ref="paypalButtonContainer"
        v-show="activeIndex === 1"
      />
      <!-- 银行支付 -->
      <div
        v-if="activeIndex === 2"
        @click="handlePayNow"
        class="bottom-button"
      >
        Pay Now
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { fetchData } from '@/utils/fetch'
import { useRoute, useRouter } from 'vue-router'
import { loadScript } from '@paypal/paypal-js'
import { gaAnalytics, buriedPointUtil } from '@/utils/utils'

const props = defineProps({
  data: {
    type: Object,
    default: () => {}
  }
})

const router = useRouter()

const route = useRoute()

const activeIndex = ref(1) // 1 paypal  2 bank

const paypalButtonContainer = ref(null)

const disabledPaypal = ref(false)

const handlePayNow = () => {
  buriedPointUtil({ eventId: 'POP207' })
  gaAnalytics('p_pay_with_bank_click', 'p_pay_with_bank_click')

  const status = props.data.b2bOrderVo.status
  if (status === 20) {
    router.push(`/bankPayment/${props.data.b2bOrderVo.orderNo}?type=repay`)
  } else {
    router.push(`/bankPayment/${props.data.b2bOrderVo.orderNo}`)
  }
}

const tradeCode = ref('')

const initPaypal = async () => {
  const { data } = await fetchData('/appb/b2b/pay/getPaypalClientId')
  try {
    const paypal = await loadScript({
      'client-id': data,
      intent: 'capture',
      components: 'buttons',
      disableFunding: 'paylater'
    })
    paypal.Buttons({
      style: {
        layout: 'vertical', // 设置按钮水平排列
        shape: 'pill', // 圆形按钮
        size: 'small', // 自适应大小
        tagline: false // 隐藏标签
      },
      createOrder: async () => { // 创建订单，返回一个订单 ID，供 PayPal 处理
        gaAnalytics('p_paypal_click', 'p_paypal_click')
        buriedPointUtil({ eventId: 'POP206' })
        const { code, data } = await fetchData('/appb/b2b/order/createOrderPay', {
          method: 'POST',
          body: JSON.stringify({
            orderNo: props.data.b2bOrderVo.orderNo,
            paymentMethodCode: 'PAYPAL_STANDARD_B2B',
            transactionNo: ''
          })
        })

        if (code === 200) {
          tradeCode.value = data.tradeCode
          return data.thirdTradeCode
        }
      },
      onApprove: async (data) => {
        const { code } = await fetchData('/appb/b2b/order/completePayAction', {
          method: 'POST',
          body: JSON.stringify({
            tradeCode: tradeCode.value,
            orderNo: props.data.b2bOrderVo.orderNo
          })
        })

        if (code === 200) {
          localStorage.setItem('ga_P_Pay_Success', true)
          router.push('/orders').then(() => {
            router.go(0)
          })
        }
      },
      onCancel: (data) => {
        console.log('用户取消支付', data)
      },
      onError: (err) => {
        console.error('支付失败', err)
      }
    }).render(paypalButtonContainer.value)
  } catch (error) {
    console.error('PayPal初始化失败:', error)
    setTimeout(() => {
      initPaypal() // 如果加载失败,3秒后重试
    }, 3000)
  }
}

const choosePaypal = () => {
  if (disabledPaypal.value) return
  activeIndex.value = 1
}

onMounted(() => {
  initPaypal()

  if (route.fullPath.includes('fromEmail') && props.data.b2bOrderVo.totalAmountUsd < 200) {
    activeIndex.value = 2
  }

  if (props.data.b2bOrderVo.totalAmountUsd >= 500) {
    activeIndex.value = 2
    disabledPaypal.value = true
  }
})
</script>

<style lang="less" scoped>
.pay-now-container {
  position: relative;
  height: 100%;
  overflow: auto;

  .body {
    background-color: white;
    border-radius: 8px;

    .payment-price {
      text-align: center;
      padding: 0 12px;

      .text {
        color: #5c5c5c;
        font-size: 12px;
        font-family: mon-500;
        line-height: 16px;
        margin-top: 24px;
      }

      .price {
        color: #052785;
        margin-top: 4px;
        font-family: mon-700;
        padding-bottom: 16px;
        border-bottom: 0.5px solid #e4e6eb;

        span:nth-child(1) {
          font-size: 20px;
          line-height: 32px;
        }
        span:nth-child(2) {
          font-size: 28px;
          line-height: 40px;
        }
        span:nth-child(2) {
          font-size: 24px;
          line-height: 32px;
        }
      }
    }

    .payment-methods {
      margin: 24px 0 0 16px;
      color: #232323;
      font-size: 14px;
      font-family: mon-700;
      line-height: 18px;
    }

    .sub-text {
      margin: 4px 0 0 16px;
      color: #5c5c5c;
      font-size: 12px;
      font-family: mon-500;
      line-height: 16px;
    }

    .payment-options {
      margin-top: 16px;
      padding: 0 16px;

      .option {
        display: flex;
        align-items: center;
        border: 1px solid #ebf1f5;
        border-radius: 8px;
        height: 64px;
        cursor: pointer;

        &:last-child {
          margin-top: 12px;
        }

        &.active {
          border: 1px solid #232323;
        }

        &.disabled {
          opacity: .5;
        }

        .radio {
          margin-left: 12px;
          width: 20px;
          height: 20px;
        }

        .image {
          width: 75px;
          height: 32px;
          margin-left: 12px;
          img {
            width: 100%;
            height: 100%;
          }
        }

        .desc {
          color: #232323;
          font-size: 13px;
          font-family: mon-600;
          margin-left: 10px;
        }
      }
    }

    .secure-payments {
      margin-top: 24px;
      padding: 0 16px;

      .content {
        display: flex;
        align-items: center;
        background-color: #f5f5f5;
        border-radius: 6px;
        padding: 16px;
        .text {
          flex: 1;
          .title {
            color: #232323;
            font-size: 14px;
            font-family: mon-600;
            line-height: 18px;
          }
          .desc {
            color: #5c5c5c;
            font-size: 12px;
            font-family: mon-500;
            line-height: 16px;
            margin-top: 8px;
          }
        }
        .image {
          width: 80px;
          height: 80px;
          margin-left: 8px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }

    .split-line {
      position: absolute;
      left: 12px;
      right: 12px;
      bottom: 76px;
      height: 0.5px;
      background-color: #e4e6eb;
    }

    .bottom-button {
      position: absolute;
      left: 16px;
      right: 16px;
      bottom: 16px;
      height: 44px;
      background-color: #4681f9;
      border-radius: 22px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;
      font-size: 14px;
      font-family: mon-600;
      cursor: pointer;
    }
  }
}

.paypal-button-container {
  position: absolute;
  bottom: 0;
  left: 28px;
  right: 28px
}
</style>
